{
  "cms.archive.action.archive": "Delete",
  "cms.archive.archiveError": "Archiving failed. Try again.",
  "cms.archive.confirm.body": "The content moves to the archive, from which you can restore it if needed.",
  "cms.archive.confirm.cancel": "Cancel",
  "cms.archive.confirm.confirm": "Delete",
  "cms.archive.confirm.title": "Delete \"{title}\"?",
  "cms.archive.deletedAt": "deleted {date}",
  "cms.archive.description": "Deleted rows.",
  "cms.archive.empty": "The archive is empty.",
  "cms.archive.errorState": "Failed to load the archive.",
  "cms.archive.loading": "Loading the archive…",
  "cms.archive.restore": "Restore",
  "cms.archive.restored": "Restored from the archive to drafts.",
  "cms.archive.restoreError": "Restore failed. Try again.",
  "cms.archive.title": "Archive",
  "cms.archive.trigger": "Archive",
  "cms.archive.type.banner": "Banner",
  "cms.archive.type.benefit": "Benefit",
  "cms.archive.type.homeCard": "Card",
  "cms.archive.type.article": "Page",
  "cms.archive.type.sidebarLink": "Button",
  "cms.archive.type.videoListing": "Lakiruutu-video"
}
